import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() type: number = 0;  // 导航的类别（0:未设置 1:加油站 2:岗位）
  @Input() level: number = 0; // 层级

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/breadcrumb/breadcrumb.component.ts